import React from "react";

const LogoIcon = () => {
	return (
		<svg
			width="64px"
			height="44px"
			viewBox="0 0 64 44">
			<title>Liam Logo</title>
			<g
				id="working"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd">
				<g
					id="home---default---desktop"
					transform="translate(-32.000000, -32.000000)"
					fill="currentColor"
					fillRule="nonzero">
					<g id="icon/logo/blk" transform="translate(32.000000, 32.000000)">
						<path
							fill="currentColor"
							d="M61.316129,28.4952381 L55.7419355,28.4952381 L31.7935484,28.4952381 L37.6774194,13.6190476 L39.7419355,13.6190476 C42.5290323,13.6190476 44.8,12.8857143 46.5548387,11.5238095 C48.3096774,10.1619048 49.1354839,8.27619048 49.1354839,6.07619048 C49.1354839,4.2952381 48.516129,2.82857143 47.2774194,1.67619048 C46.2451613,0.628571429 44.6967742,0 42.9419355,0 C39.3290323,0 36.7483871,2.2 34.9935484,6.4952381 L34.0645161,8.8 L5.57419355,8.8 L2.37419355,8.8 C1.03225806,8.8 0,9.84761905 0,11.2095238 C0,12.5714286 1.03225806,13.6190476 2.37419355,13.6190476 L3.61290323,13.6190476 L32.1032258,13.6190476 L26.116129,28.4952381 L19.0967742,28.4952381 C16.6193548,28.4952381 14.6580645,28.9142857 13.2129032,29.752381 C12.0774194,30.3809524 11.2516129,31.3238095 10.5290323,32.4761905 C9.90967742,33.6285714 9.6,34.8857143 9.6,36.247619 C9.6,38.447619 10.3225806,40.2285714 11.8709677,41.5904762 C13.4193548,42.952381 15.2774194,43.6857143 17.6516129,43.6857143 C20.5419355,43.6857143 23.0193548,42.6380952 25.2903226,40.647619 C26.116129,39.8095238 26.8387097,39.0761905 27.3548387,38.2380952 C27.8709677,37.4 28.5935484,35.9333333 29.5225806,33.8380952 L29.7290323,33.3142857 L61.2129032,33.3142857 C62.5548387,33.3142857 63.5870968,32.2666667 63.5870968,30.9047619 C63.5870968,29.5428571 62.5548387,28.4952381 61.316129,28.4952381 Z M40.1548387,7.43809524 C40.8774194,5.55238095 41.7032258,4.60952381 42.6322581,4.60952381 C43.6645161,4.60952381 44.0774194,5.13333333 44.0774194,6.18095238 C44.0774194,6.91428571 43.7677419,7.54285714 43.0451613,8.06666667 C42.3225806,8.59047619 41.4967742,8.8 40.4645161,8.8 L39.5354839,8.8 L40.1548387,7.43809524 Z M21.4709677,37.2952381 C20.3354839,38.2380952 19.2,38.7619048 18.0645161,38.7619048 C17.2387097,38.7619048 16.516129,38.552381 15.8967742,38.0285714 C15.2774194,37.5047619 15.0709677,36.8761905 15.0709677,36.1428571 C15.0709677,34.2571429 16.4129032,33.3142857 18.9935484,33.3142857 L24.2580645,33.3142857 C23.5354839,34.9904762 22.6064516,36.352381 21.4709677,37.2952381 Z"
							id="Shape"></path>
					</g>
				</g>
			</g>
		</svg>
	);
};

export default LogoIcon;
